<!-- EDIT MODE -->
<div *ngIf="editable; else previewMode">

  <!-- Introduction -->
  <div class="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 mb-6">

    <label class="block text-sm font-medium text-gray-600 mb-3">
      {{ 'CREDIT_SECTION_IRS.INTRODUCTION' | translate }}
    </label>

    <app-rich-text-editor
      [(ngModel)]="config.introduction"
      minHeight="120px"
      [placeholder]="'CREDIT_SECTION_IRS.INTRODUCTION_PLACEHOLDER' | translate"
    ></app-rich-text-editor>

  </div>

  <!-- Scorecard Table -->
  <div class="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden mb-6">

    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 bg-gray-50 border-b">

      <div>

        <h3 class="font-semibold text-gray-800">
          {{ 'CREDIT_SECTION_IRS.SCORECARD' | translate }}
        </h3>

        <p class="text-sm text-gray-500 mt-1">
          {{ 'CREDIT_SECTION_IRS.SCORECARD_SUBTITLE' | translate }}
        </p>

      </div>

      <button
        type="button"
        (click)="addRow()"
        class="section-add-btn">

        <span class="text-lg">+</span>
        {{ 'CREDIT_SECTION.ADD_ROW' | translate }}

      </button>

    </div>

    <!-- Table -->
    <div class="overflow-x-auto">

      <table class="w-full">

        <thead>

          <tr class="bg-[#1E2A78] text-white">

            <th class="px-4 py-3 text-start">
              {{ 'CREDIT_SECTION_IRS.CATEGORY' | translate }}
            </th>

            <th class="px-4 py-3 text-start">
              {{ 'CREDIT_SECTION_IRS.WEIGHT' | translate }}
            </th>

            <th class="px-4 py-3 text-start">
              {{ 'CREDIT_SECTION_IRS.CURRENT_SCORE' | translate }}
            </th>

            <th class="px-4 py-3 text-start">
              {{ 'CREDIT_SECTION_IRS.CURRENT_RATING' | translate }}
            </th>

            <th class="px-4 py-3 text-start">
              {{ 'CREDIT_SECTION_IRS.PREVIOUS_SCORE' | translate }}
            </th>

            <th class="px-4 py-3 text-start">
              {{ 'CREDIT_SECTION_IRS.PREVIOUS_RATING' | translate }}
            </th>

            <th class="px-4 py-3 text-center">
              {{ 'COMMON.ACTION' | translate }}
            </th>

          </tr>

        </thead>

        <tbody>

          <tr
            *ngFor="let row of config.rows; let i=index"
            class="border-b">

            <td class="p-3">

              <input
                [(ngModel)]="row.category"
                [placeholder]="'CREDIT_SECTION_IRS.CATEGORY' | translate"
                class="w-full h-10 px-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 outline-none">

            </td>

            <td class="p-3">

              <input
                [(ngModel)]="row.weight"
                [placeholder]="'CREDIT_SECTION_IRS.WEIGHT' | translate"
                class="w-full h-10 px-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 outline-none">

            </td>

            <td class="p-3">

              <input
                [(ngModel)]="row.currentScore"
                [placeholder]="'CREDIT_SECTION_IRS.SCORE' | translate"
                class="w-full h-10 px-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 outline-none">

            </td>

            <td class="p-3">

              <input
                [(ngModel)]="row.currentRating"
                [placeholder]="'CREDIT_SECTION_IRS.RATING' | translate"
                class="w-full h-10 px-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 outline-none">

            </td>

            <td class="p-3">

              <input
                [(ngModel)]="row.previousScore"
                [placeholder]="'CREDIT_SECTION_IRS.SCORE' | translate"
                class="w-full h-10 px-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 outline-none">

            </td>

            <td class="p-3">

              <input
                [(ngModel)]="row.previousRating"
                [placeholder]="'CREDIT_SECTION_IRS.RATING' | translate"
                class="w-full h-10 px-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 outline-none">

            </td>

            <td class="p-3 text-center">

              <button
                type="button"
                (click)="requestRemoveRow(i)"
                class="section-delete-btn">

                {{ 'COMMON.DELETE' | translate }}

              </button>

            </td>

          </tr>

        </tbody>

      </table>

    </div>

  </div>

  <!-- Final Score -->
  <div class="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 mb-6">

    <h3 class="font-semibold text-gray-800 mb-5">
      {{ 'CREDIT_SECTION_IRS.FINAL_SCORE' | translate }}
    </h3>

    <div class="grid md:grid-cols-4 gap-4">

      <input
        [(ngModel)]="config.finalScore.currentScore"
        [placeholder]="'CREDIT_SECTION_IRS.CURRENT_SCORE' | translate"
        class="h-12 px-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 outline-none">

      <input
        [(ngModel)]="config.finalScore.currentRating"
        [placeholder]="'CREDIT_SECTION_IRS.CURRENT_RATING' | translate"
        class="h-12 px-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 outline-none">

      <input
        [(ngModel)]="config.finalScore.previousScore"
        [placeholder]="'CREDIT_SECTION_IRS.PREVIOUS_SCORE' | translate"
        class="h-12 px-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 outline-none">

      <input
        [(ngModel)]="config.finalScore.previousRating"
        [placeholder]="'CREDIT_SECTION_IRS.PREVIOUS_RATING' | translate"
        class="h-12 px-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 outline-none">

    </div>

  </div>

  <!-- Conclusion -->
  <div class="bg-white rounded-2xl border border-gray-200 shadow-sm p-6">

    <label class="block text-sm font-medium text-gray-600 mb-3">
      {{ 'CREDIT_SECTION_IRS.CONCLUSION' | translate }}
    </label>

    <app-rich-text-editor
      [(ngModel)]="config.conclusion"
      minHeight="200px"
      [placeholder]="'CREDIT_SECTION_IRS.CONCLUSION_PLACEHOLDER' | translate"
    ></app-rich-text-editor>

  </div>

</div>

<app-popup
  [(show)]="showDeletePopup"
  title="CREDIT_SECTION.DELETE_ROW"
  type="confirm"
  [message]="deleteMessage"
  confirmText="COMMON.DELETE"
  cancelText="COMMON.CANCEL"
  (confirmed)="confirmRemoveRow()"
></app-popup>

<!-- PREVIEW MODE -->
<ng-template #previewMode>

  <!-- Introduction -->
  <div
    *ngIf="config.introduction"
    class="bg-white rounded-xl border border-gray-200 p-6 mb-6">

    <div class="rich-text-content text-gray-700" [innerHTML]="config.introduction | richText"></div>

  </div>

  <!-- Score Table -->
  <div class="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden mb-6">

    <table class="w-full">

      <thead>

        <tr class="bg-[#1E2A78] text-white">

          <th class="px-4 py-3 text-start">
            {{ 'CREDIT_SECTION_IRS.CATEGORY' | translate }}
          </th>

          <th class="px-4 py-3 text-start">
            {{ 'CREDIT_SECTION_IRS.WEIGHT' | translate }}
          </th>

          <th class="px-4 py-3 text-start">
            {{ 'CREDIT_SECTION_IRS.CURRENT_SCORE' | translate }}
          </th>

          <th class="px-4 py-3 text-start">
            {{ 'CREDIT_SECTION_IRS.CURRENT_RATING' | translate }}
          </th>

          <th class="px-4 py-3 text-start">
            {{ 'CREDIT_SECTION_IRS.PREVIOUS_SCORE' | translate }}
          </th>

          <th class="px-4 py-3 text-start">
            {{ 'CREDIT_SECTION_IRS.PREVIOUS_RATING' | translate }}
          </th>

        </tr>

      </thead>

      <tbody>

        <tr
          *ngFor="let row of config.rows"
          class="border-b">

          <td class="px-4 py-3">
            {{ row.category }}
          </td>

          <td class="px-4 py-3">
            {{ row.weight }}
          </td>

          <td class="px-4 py-3">
            {{ row.currentScore }}
          </td>

          <td class="px-4 py-3">
            {{ row.currentRating }}
          </td>

          <td class="px-4 py-3">
            {{ row.previousScore }}
          </td>

          <td class="px-4 py-3">
            {{ row.previousRating }}
          </td>

        </tr>

      </tbody>

      <tfoot>

        <tr class="bg-indigo-50 font-semibold">

          <td colspan="2" class="px-4 py-3">
            {{ 'CREDIT_SECTION_IRS.FINAL_SCORE' | translate }}
          </td>

          <td class="px-4 py-3">
            {{ config.finalScore.currentScore }}
          </td>

          <td class="px-4 py-3">
            {{ config.finalScore.currentRating }}
          </td>

          <td class="px-4 py-3">
            {{ config.finalScore.previousScore }}
          </td>

          <td class="px-4 py-3">
            {{ config.finalScore.previousRating }}
          </td>

        </tr>

      </tfoot>

    </table>

  </div>

  <!-- Conclusion -->
  <div
    *ngIf="config.conclusion"
    class="bg-white rounded-xl border border-gray-200 p-6">

    <h4 class="text-xl font-semibold text-[#1E2A78] mb-4">
      {{ 'CREDIT_SECTION_IRS.CONCLUSION' | translate }}
    </h4>

    <div class="rich-text-content text-gray-700" [innerHTML]="config.conclusion | richText"></div>

  </div>

</ng-template>